import React from "react";
import QRLContent from "FunctionalComponents/QRL/QRLContent";

const QRL = () => {
    return (
        <>
            <QRLContent/>
        </>
    );
};

export default QRL;
